import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=516fd623&scoped=true"
import script from "./Beneficios.vue?vue&type=script&lang=ts"
export * from "./Beneficios.vue?vue&type=script&lang=ts"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=516fd623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516fd623",
  null
  
)

export default component.exports